import { IdentifiableDto } from "./identifiable.dto";

export class FileDto extends IdentifiableDto {
   name!: string;
   timestampCreated!: Date;
   timestampUpdated!: Date;
   url!: string;
   size!: number;
   mimeType!: string;
}